import { sharedAuthTranslations } from "@org-avp/avp-avengers-ui-shared-auth";
import { sharedComponentsTranslations } from "@org-avp/avp-avengers-ui-shared-components";
import { Translations, viewRegistry } from "@org-avp/avp-avengers-ui-shared-utils";
import { blacklistViewModule } from "@org-avp/avp-avengers-ui-views-blacklist";
import { configurationManagerViewModule } from "@org-avp/avp-avengers-ui-views-configuration-manager";
import { geometryViewModule } from "@org-avp/avp-avengers-ui-views-geometry";
import { geometryManagerViewModule } from "@org-avp/avp-avengers-ui-views-geometry-manager";
import { homeViewModule } from "@org-avp/avp-avengers-ui-views-home";
import { idManagerViewModule } from "@org-avp/avp-avengers-ui-views-id-manager";
import { imprintViewModule } from "@org-avp/avp-avengers-ui-views-imprint";
import { kvsSearchViewModule } from "@org-avp/avp-avengers-ui-views-kvs-search";
import { materialInfoViewModule } from "@org-avp/avp-avengers-ui-views-material-info";
import { megTemplateViewModule } from "@org-avp/avp-avengers-ui-views-meg-template";
import { operatorViewModule } from "@org-avp/avp-avengers-ui-views-operator";
import { partlistViewModule } from "@org-avp/avp-avengers-ui-views-partlist";
import { prFamilyInfoViewModule } from "@org-avp/avp-avengers-ui-views-pr-family-info";
import { projectManagementViewModule } from "@org-avp/avp-avengers-ui-views-project-management";
import { projectStructureViewModule } from "@org-avp/avp-avengers-ui-views-project-structure";
import { qaMonitorViewModule } from "@org-avp/avp-avengers-ui-views-qa-monitor";
import { roleManagementViewModule } from "@org-avp/avp-avengers-ui-views-role-management";
import { settingsViewModule } from "@org-avp/avp-avengers-ui-views-settings";
import { targetManagerViewModule } from "@org-avp/avp-avengers-ui-views-target-manager";
import { targetMaterialViewModule } from "@org-avp/avp-avengers-ui-views-target-material";
import { templateViewModule } from "@org-avp/avp-avengers-ui-views-template";
import { tmmEditorViewModule } from "@org-avp/avp-avengers-ui-views-tmm-editor";
import { updateMonitorViewModule } from "@org-avp/avp-avengers-ui-views-update-monitor";
import de from "../../public/locales/de.json";
import en from "../../public/locales/en.json";

export const registerAllViews = (): Promise<void> => {
  viewRegistry.registerView(homeViewModule, { type: "fullSize", menuLocation: "top", menuDividerBelow: true, overlay: true });
  viewRegistry.registerView(projectManagementViewModule, { type: "fullSize", menuLocation: "top", overlay: true });
  viewRegistry.registerView(roleManagementViewModule, { type: "fullSize", menuLocation: "bottom", overlay: true });
  viewRegistry.registerView(imprintViewModule, { type: "fullSize", menuLocation: "bottom", overlay: true });
  viewRegistry.registerView(settingsViewModule, { type: "fullSize", menuLocation: "bottom", overlay: true });
  viewRegistry.registerView(operatorViewModule, { type: "fullSize" });

  viewRegistry.registerView(configurationManagerViewModule, { type: "modular" });
  viewRegistry.registerView(prFamilyInfoViewModule, { type: "modular" });
  viewRegistry.registerView(geometryViewModule, { type: "modular" });
  viewRegistry.registerView(geometryManagerViewModule, { type: "modular" });
  viewRegistry.registerView(kvsSearchViewModule, { type: "modular" });
  viewRegistry.registerView(updateMonitorViewModule, { type: "modular" });
  viewRegistry.registerView(materialInfoViewModule, { type: "modular" });
  viewRegistry.registerView(partlistViewModule, { type: "modular" });
  viewRegistry.registerView(projectStructureViewModule, { type: "modular" });
  viewRegistry.registerView(targetManagerViewModule, { type: "modular" });
  viewRegistry.registerView(idManagerViewModule, { type: "modular" });
  viewRegistry.registerView(targetMaterialViewModule, { type: "modular" });
  viewRegistry.registerView(tmmEditorViewModule, { type: "modular" });
  viewRegistry.registerView(qaMonitorViewModule, { type: "modular" });
  viewRegistry.registerView(templateViewModule, { type: "modular" });
  viewRegistry.registerView(blacklistViewModule, { type: "modular" });
  viewRegistry.registerView(megTemplateViewModule, { type: "modular" });

  return Promise.resolve();
};

const appShellTranslations: Translations = { de, en };
export const selectTranslations = () => [
  appShellTranslations,
  sharedAuthTranslations,
  sharedComponentsTranslations,
  ...Array.from(viewRegistry.getViews().values()).map((it) => it.translations),
];
